export interface INoticeState {
  notices: Array<{
    type: 'announce' | 'mediatag';
    mediaTagId?: string;
    createTime: string;
    startTime: string;
    priority: number;
    placements: Array<{
      position?: string;
      webCategory?: string;
    }>;
    contents: Array<{
      contentId: number;
      title: string;
      description?: string;
      linkUrl?: string;
      imageUrl?: string;
      pos?: number;
    }>;
  }>;
}
const initialState: INoticeState = {
  notices: [
    {
      priority: 0,
      type: 'announce',
      createTime: '',
      startTime: '',
      placements: [{}],
      contents: []
    }
  ]
};
export default (state: INoticeState = initialState) => {
  return state;
};
